import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import {
  ConnectDeliveryService,
  IntegrationStatusNum,
} from '@/pages/store-management/master-stores/service';
import { StoreManagementMasterStoreService } from '@/services/StoreManagement/MasterStores/StoreManagementMasterStoreService';

export type StoreManagementMasterStoreSearchListParams = {
  limit: number;
  currentPage: number;
  name: string;
  authStoreIds: number[];
  associateBrandIds: number[];
  deliveryServiceIds?: number[];
};

export type DeliveryStore = {
  id: string;
  delivery_service_name: ConnectDeliveryService;
  integration_status: IntegrationStatusNum;
};

export type StoreManagementMasterStoreSearchList = {
  id: number;
  name: string;
  auth_store_name: string;
  brand_name: string;
  business_number: string | null;
  delivery_stores: DeliveryStore[];
};
export type StoreManagementMasterStoreSearchListResponse = {
  master_stores: StoreManagementMasterStoreSearchList[];
  count: number;
};

export const useStoreManagementMasterStoreSearchList = async (
  params: StoreManagementMasterStoreSearchListParams
): Promise<StoreManagementMasterStoreSearchListResponse> => {
  const storeManagementStoreService = new StoreManagementMasterStoreService(
    getClient()
  );
  try {
    return await storeManagementStoreService.searchList(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
